import React from 'react';

export default class FlashcardAnswers extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  createAnswers() {
    return this.props.problems.map((prob, index) => {
      return (
        <div className="flashcard-creator__answer flashcard" key={index}>
          <span className="flashcard-creator__answer-value">{prob[0]}</span>
        </div>
      );
    });
  }

  render() {
    const answers = this.createAnswers();
    return (
      <div className="flashcard-creator__answers">
        <h1 className="flashcard-creator__print-heading">Back of Print</h1>
        {answers}
      </div>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/flashcard-creator/flashcard-answers.js
 **/